import { useEffect, useState } from "react";
import React from "react";
import { ChevronDoubleUpIcon } from "@heroicons/react/24/outline";

const ToTopScroll = () => {
  const classNames = (...classes) => {
    return classes.filter(Boolean).join(" ");
  };

  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div className="fixed bottom-3 left-5">
      <button
        type="button"
        onClick={scrollToTop}
        className={classNames(
          isVisible ? "opacity-100" : "opacity-0",
          "bg-pink-500 hover:bg-pink-500 focus:ring-pink-500 inline-flex items-center rounded-full p-3 text-white shadow-sm transition-opacity focus:outline-none focus:ring-2 focus:ring-offset-2"
        )}
      >
        <ChevronDoubleUpIcon className="w-6 h-6" aria-hidden="true" />
      </button>
    </div>
  );
};

export default ToTopScroll;
